import {SignUpValidateToken} from 'domain/usecases';
import {RemoteSignUpValidateToken} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeSignUpValidateToken = (): SignUpValidateToken =>
	new RemoteSignUpValidateToken(
		makeBFFApiUrl(EntryFlowEndPoints.signUpValidateToken),
		makeAuthorizeHttpClientDecorator(),
	);
